import { irwin, featureFlags, env } from './'

export const FEATURE_FLAG_CONFIG = {
  url: `${featureFlags?.baseUrl || irwin.baseUrl}/admin/feature/flags/proxy`,
  clientKey: featureFlags.clientKey,
  refreshInterval: 600,
  appName: 'admin-fe',
  environment: env,
}
